export default {


  npm_package_version: '3.23.10.2'

};

